/**
 * Compact ⓘ hover tip for teacher dashboard chrome.
 * Put beside labels — not wrapping whole clickable KPI cards.
 */
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function HelpTip({
  title,
  label = 'More info',
  iconColor = 'rgba(200, 226, 255, 0.75)',
  size = 16,
  sx = {}
}) {
  if (!title) return null;
  return (
    <Tooltip
      arrow
      enterDelay={350}
      leaveDelay={100}
      describeChild
      title={
        <span style={{ display: 'block', maxWidth: 260, lineHeight: 1.45, fontSize: 12.5 }}>
          {title}
        </span>
      }
    >
      <IconButton
        size="small"
        aria-label={label}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        sx={{
          p: 0.2,
          color: iconColor,
          verticalAlign: 'middle',
          '&:hover': { color: '#e8f4ff', bgcolor: 'rgba(255,255,255,0.08)' },
          ...sx
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: size }} />
      </IconButton>
    </Tooltip>
  );
}

/** Short copy for hub / gradebook KPI ids */
export const TEACHER_KPI_HELP = {
  roster: 'Active students in the selected class (or all your classes combined).',
  avg_completion: 'Average pathway completion from verified Learning progress — not page views.',
  avg_grade: 'Average gradebook % using your class point scheme (and any teacher overrides).',
  on_track:
    'Students at or above the on-track bar (scheme score). Uses class default or a student’s IEP/504 bar. Click to open that list.',
  needs_help:
    'Students below the low-mastery pathway bar. Click to open Intervention Radar for the selected class.',
  radar:
    'Students flagged for idle time, low mastery, or behind the class — respects IEP/504 pacing supports. Click to open Radar.'
};
